export class Credential {
    /**
     * Constructeur.
     * @param userName : Identifiant de connexion de l'utilisateur.
     * @param password : Mot de passe de l'utilisateur.
     */
    public constructor(
        public account: string,
        public password: string
    ) {}
}
